import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Stack, Switch, FormControlLabel } from "@mui/material";
import { Card, CardBody, Row, Col, Form, Button, ButtonGroup, Modal, Nav } from "react-bootstrap";
import Select from "react-select";
import DownloadExcel from "utils/DownloadExcel";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import * as yup from "yup";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { StepperLabelWizard } from "layouts/StepperLabelWizard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { nanoid } from "nanoid";
import { useReactToPrint } from "react-to-print";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { getDiscountValue, NumberFormat, getInfoAdminSystem, filterTextAndNum, getPrefixName, WDA } from "utils/HelperFunction";
import { ModalAllder } from "layouts/ModalAllder";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import ColumnResizer from "react-table-column-resizer";
import { invoice } from "../../redux/handlers/invoice/invoice.handler";
import { getInvoiceByID } from "../../redux/handlers/invoice/getInvoiceByID.handler";
import { getAllMstBusiness } from "../../redux/handlers/master/getAllMstBusiness.handler";
import { uploadInvoice } from "../../redux/handlers/invoice/uploadInvoice.handler";
import { createInvoice, clearcreateInvoice } from "../../redux/handlers/invoice/createInvoice.handler";
import { updateInvoice, clearupdateInvoice } from "../../redux/handlers/invoice/updateInvoice.handler";
import { updateInvoiceCancel, clearupdateInvoiceCancel } from "../../redux/handlers/invoice/updateInvoiceCancel.handler";
import ThaiBahtText from "thai-baht-text";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PaymentsIcon from "@mui/icons-material/Payments";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import { Page, Text, View, Document, StyleSheet, Font, Image, pdf } from "@react-pdf/renderer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
export function Invoice() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), rowData = _useState1[0], setRowData = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), tabStatus = _useState2[0], setTabStatus = _useState2[1];
    var _useState3 = _sliced_to_array(useState(1), 2), pageId = _useState3[0], setPageId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(10), 2), pageSize = _useState4[0], setPageSize = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), sortModel = _useState5[0], setSortModel = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), loading = _useState6[0], setLoading = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), totalPage = _useState7[0], setTotalPage = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), totalAmount = _useState8[0], setTotalAmount = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), sDate = _useState9[0], setSDate = _useState9[1];
    var _useState10 = _sliced_to_array(useState(""), 2), eDate = _useState10[0], setEDate = _useState10[1];
    var invoiceReducer = useAppSelector(function(state) {
        return state.invoiceReducer;
    });
    useEffect(function() {
        setIsLoading(invoiceReducer.isFetching);
        if (invoiceReducer.data) {
            var _invoiceReducer_data_data, _invoiceReducer_data;
            var data = invoiceReducer.data.data.data;
            var pagination = (invoiceReducer === null || invoiceReducer === void 0 ? void 0 : (_invoiceReducer_data = invoiceReducer.data) === null || _invoiceReducer_data === void 0 ? void 0 : (_invoiceReducer_data_data = _invoiceReducer_data.data) === null || _invoiceReducer_data_data === void 0 ? void 0 : _invoiceReducer_data_data.pagination) || {};
            setRowData(data);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
        }
    }, [
        invoiceReducer
    ]);
    useEffect(function() {
        var data = _object_spread(_object_spread_props(_object_spread({}, filterText && {
            searchtxt: filterText
        }, tabStatus && {
            status: parseInt(tabStatus)
        }), {
            pageId: parseInt(pageId),
            pageSize: parseInt(pageSize)
        }), sDate && {
            sDate: moment(sDate).format("YYYY-MM-DD")
        }, eDate && {
            eDate: moment(eDate).format("YYYY-MM-DD")
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        });
        dispatch(invoice(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        filterText,
        pageId,
        pageSize,
        sortModel,
        sDate,
        eDate,
        tabStatus
    ]);
    var columns = [
        {
            name: "เลขที่ใบเสร็จ",
            selector: function(row) {
                return row.inv_invoice_code;
            },
            center: "true",
            width: "160px",
            sortable: true,
            sortField: "inv_invoice_code",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/invoice/edit/" + row.inv_invoice_id,
                        children: row.inv_invoice_code ? row.inv_invoice_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "อ้างอิงใบแจ้งหนี้",
            selector: function(row) {
                return row.BlBilling ? row.BlBilling.bl_billing_code : "-";
            },
            center: "true",
            width: "160px",
            sortable: true,
            sortField: "bl_billing_code",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/billing/edit/" + row.inv_invoice_billid,
                        children: row.BlBilling ? row.BlBilling.bl_billing_code : "-"
                    })
                });
            }
        },
        {
            name: "ชื่อลูกค้า",
            sortable: true,
            sortField: "inv_invoice_businesstype",
            selector: function(row) {
                return row.inv_invoice_businesstype ? row.inv_invoice_businesstype == 1 ? row.inv_invoice_fname ? row.inv_invoice_fname + " " + row.inv_invoice_lname : "-" : row.inv_invoice_name ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.inv_invoice_name,
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption",
                            children: row.inv_invoice_taxid
                        })
                    ]
                }) : "-" : "-";
            },
            width: "200px"
        },
        {
            name: "วันที่ออกเอกสาร",
            selector: function(row) {
                return row.inv_invoice_issuedate ? moment(row.inv_invoice_issuedate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            sortable: true,
            sortField: "inv_invoice_issuedate"
        },
        {
            name: "จำนวนสินค้า",
            center: "true",
            sortable: true,
            sortField: "inv_invoice_totallist",
            selector: function(row) {
                return row.inv_invoice_totallist ? row.inv_invoice_totallist : "0";
            }
        },
        {
            name: "มูลค่าสุทธิ",
            sortable: true,
            sortField: "inv_invoice_totalnet",
            selector: function(row) {
                return row.inv_invoice_totalnet ? NumberFormat(row.inv_invoice_totalnet, 2) : "0.00";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.inv_invoice_status;
            },
            sortable: true,
            sortField: "inv_invoice_status",
            center: "true",
            // width: "150px",
            cell: function(row, index, column, id) {
                return row.inv_invoice_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ร่างแบบ"
                }) || row.inv_invoice_status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ยกเลิก"
                }) || row.inv_invoice_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgb(247 9 236)",
                        backgroundColor: "rgb(248 229 251)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รับชำระ"
                });
            }
        }
    ];
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    // // Handle Page Size Change
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายรับ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบเสร็จรับเงิน"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "ใบเสร็จรับเงิน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        defaultActiveKey: tabStatus,
                        onSelect: function(selectedKey) {
                            return setTabStatus(selectedKey);
                        },
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: "ทั้งหมด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "1",
                                    children: "แบบร่าง"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "2",
                                    children: "รับชำระ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "3",
                                    children: "ยกเลิก"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 2,
                                            lg: 1,
                                            children: /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                                    data: rowData,
                                                    filename: "ใบเสร็จรับเงิน"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 10,
                                            lg: 6,
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "row",
                                                justifyContent: "flex-start",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: " mb-2 px-2 w-[190px] ml-5",
                                                        children: "ค้นหาวันที่"
                                                    }),
                                                    /*#__PURE__*/ _jsx(DatePicker, {
                                                        selected: sDate,
                                                        onChange: function(date) {
                                                            return setSDate(date);
                                                        },
                                                        dateFormat: "dd-MM-yyyy",
                                                        className: "form-control px-2 mb-2",
                                                        isClearable: true
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-2 px-2",
                                                        children: "ถึง"
                                                    }),
                                                    /*#__PURE__*/ _jsx(DatePicker, {
                                                        selected: eDate,
                                                        onChange: function(date) {
                                                            return setEDate(date);
                                                        },
                                                        dateFormat: "dd-MM-yyyy",
                                                        className: "form-control px-2 mb-2",
                                                        isClearable: true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 3,
                                            children: /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control mb-3 ",
                                                placeholder: "ค้นหาเลขใบเสร็จรับเงิน",
                                                onKeyUp: function(e) {
                                                    return setFilterText(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 2,
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                className: "btn btn-st-3 w-100",
                                                to: "/invoice/create",
                                                children: "สร้างใบเสร็จรับเงิน"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                item: rowData,
                                columns: columns,
                                isSelectRows: false,
                                currentPage: pageId,
                                currentPageSize: pageSize,
                                onChangePage: handleChangePage,
                                onChangePageSize: handleChangeRowsPerPage,
                                totalPage: totalPage,
                                totalAmount: totalAmount,
                                sortModel: sortModel,
                                onChangeSort: setSortModel,
                                handleSort: handleSort,
                                loading: loading
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export function InvoiceManage() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var poID = useParams().poID;
    var _useState = _sliced_to_array(useState({
        inv_invoice_vattype: 1,
        inv_invoice_issuedate: new Date(),
        inv_invoice_status: 1,
        inv_invoice_discounttype: 1,
        inv_invoice_discount: 0,
        inv_invoice_tax: 0,
        inv_invoice_vat: 0
    }), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), formdisabled = _useState1[0], setFormdisabled = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), stepper = _useState2[0], setStepper = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), supplierInfos = _useState3[0], setSupplierInfos = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), productRow = _useState4[0], setProductRow = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumrowNoDiscount = _useState5[0], setSumrowNoDiscount = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumrowBeforeVat = _useState6[0], setSumrowBeforeVat = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumrowTotalNet = _useState7[0], setSumrowTotalNet = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), sumrowQty = _useState8[0], setSumrowQty = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), sumrowPrice = _useState9[0], setSumrowPrice = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), sumrowDiscount = _useState10[0], setSumrowDiscount = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), sumDiscount = _useState11[0], setSumDiscount = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), sumrowVat = _useState12[0], setSumrowVat = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), sumrowTax = _useState13[0], setSumrowTax = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), docPath = _useState14[0], setDocPath = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), docPathDel = _useState15[0], setDocPathDel = _useState15[1];
    var _useState16 = _sliced_to_array(useState(""), 2), payDate = _useState16[0], setPayDate = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), payment = _useState17[0], setPayment = _useState17[1];
    var _useState18 = _sliced_to_array(useState(false), 2), taxSwitch = _useState18[0], setTaxSwitch = _useState18[1];
    var _useState19 = _sliced_to_array(useState(0), 2), sumVat = _useState19[0], setSumVat = _useState19[1];
    var _useState20 = _sliced_to_array(useState(""), 2), remark = _useState20[0], setRemark = _useState20[1];
    var _useState21 = _sliced_to_array(useState(false), 2), textsuccess = _useState21[0], setTextsuccess = _useState21[1];
    var _useState22 = _sliced_to_array(useState(false), 2), modalsuccess = _useState22[0], setModalsuccess = _useState22[1];
    var _useState23 = _sliced_to_array(useState([]), 2), productRowDel = _useState23[0], setProductRowDel = _useState23[1];
    var _useState24 = _sliced_to_array(useState({}), 2), dataPrint = _useState24[0], setDataPrint = _useState24[1];
    var schema = yup.object().shape({});
    var _useState25 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        contractName: "",
        contactPhone: "",
        contactEmail: ""
    }), 2), partnerInfo = _useState25[0], setPartnerInfo = _useState25[1];
    var optionsMstPayment = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธนาคาร"
        },
        {
            value: 3,
            label: "เช็คเงินสด"
        }
    ];
    var optionsMstPriceType = [
        {
            value: 1,
            label: "รวมภาษี"
        },
        {
            value: 2,
            label: "ไม่รวมภาษี"
        }
    ];
    var optionsMstDiscountType = [
        {
            value: 1,
            label: "บาท"
        },
        {
            value: 2,
            label: "เปอร์เซ็น"
        }
    ];
    var optionsVat = [
        {
            label: "ไม่มี",
            value: 0
        },
        {
            label: "3%",
            value: 3
        },
        {
            label: "7%",
            value: 7
        },
        {
            label: "10%",
            value: 10
        }
    ];
    var _useState26 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        productsStock: "",
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState26[0], setColumDisplay = _useState26[1];
    var _useState27 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 250,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState27[0], setModalDel = _useState27[1];
    var getAllMstBusinessReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessReducer;
    });
    var createInvoiceReducer = useAppSelector(function(state) {
        return state.createInvoiceReducer;
    });
    var updateInvoiceReducer = useAppSelector(function(state) {
        return state.updateInvoiceReducer;
    });
    var getInvoiceByIDReducer = useAppSelector(function(state) {
        return state.getInvoiceByIDReducer;
    });
    useEffect(function() {
        dispatch(getAllMstBusiness());
        if (dataID) {
            dispatch(getInvoiceByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        dataID
    ]);
    useEffect(function() {
        setIsLoading(createInvoiceReducer.isFetching);
        if (createInvoiceReducer.data && !createInvoiceReducer.isError) {
            setTextsuccess("สร้างใบเสร็จ");
            setModalsuccess(true);
            // setFormdisabled(true);
            dispatch(clearcreateInvoice());
            navigate("/invoice");
        }
    }, [
        createInvoiceReducer
    ]);
    useEffect(function() {
        setIsLoading(updateInvoiceReducer.isFetching);
        if (updateInvoiceReducer.data && !updateInvoiceReducer.isError) {
            setTextsuccess("แก้ไขใบเสร็จ");
            setModalsuccess(true);
            // setFormdisabled(true);
            dispatch(clearupdateInvoice());
            navigate("/invoice");
        }
    }, [
        updateInvoiceReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllMstBusinessReducer.isFetching || getInvoiceByIDReducer.isFetching);
        if (dataID) {
            if (getInvoiceByIDReducer.data) {
                var getData = getInvoiceByIDReducer.data.data;
                console.log("getInvoiceByIDReducer", getData);
                setDataPrint(getData);
                setStepper(getData.inv_invoice_status == 2 ? getData.inv_invoice_status + 1 : 1);
                var _obj;
                setFormdata((_obj = {
                    inv_invoice_businessid: getData.inv_invoice_businessid,
                    inv_invoice_id: getData.inv_invoice_id,
                    inv_invoice_discount: getData.inv_invoice_discount ? getData.inv_invoice_discount : 0,
                    inv_invoice_discountreal: getData.inv_invoice_discountreal ? getData.inv_invoice_discountreal : 0,
                    inv_invoice_discounttype: getData.inv_invoice_discounttype ? getData.inv_invoice_discounttype : 1,
                    inv_invoice_pricediscount: getData.inv_invoice_pricediscount ? getData.inv_invoice_pricediscount : 0,
                    inv_invoice_taxinvoice: getData.inv_invoice_taxinvoice,
                    inv_invoice_taxstatus: getData.inv_invoice_taxstatus ? getData.inv_invoice_taxstatus : 1,
                    inv_invoice_totallist: getData.inv_invoice_totallist,
                    inv_invoice_totalnet: getData.inv_invoice_totalnet ? getData.inv_invoice_totalnet : 0,
                    inv_invoice_totalnettax: getData.inv_invoice_totalnettax ? getData.inv_invoice_totalnettax : 0,
                    inv_invoice_totalprice: getData.inv_invoice_totalprice ? getData.inv_invoice_totalprice : 0,
                    inv_invoice_totaltax: getData.inv_invoice_totaltax ? getData.inv_invoice_totaltax : 0,
                    inv_invoice_totalvat: getData.inv_invoice_totalvat ? getData.inv_invoice_totalvat : 0,
                    inv_invoice_code: getData.inv_invoice_code,
                    inv_invoice_issuedate: getData.inv_invoice_issuedate ? new Date(getData.inv_invoice_issuedate) : "",
                    inv_invoice_vattype: getData.inv_invoice_vattype,
                    inv_invoice_status: getData.inv_invoice_status ? getData.inv_invoice_status : 1,
                    inv_invoice_refercode: getData.inv_invoice_refercode ? getData.inv_invoice_refercode : "",
                    inv_invoice_refer: getData.BlBilling ? getData.BlBilling.bl_billing_code : "",
                    inv_invoice_categoryid: getData.inv_invoice_categoryid,
                    inv_invoice_suffixname: getData.inv_invoice_suffixname,
                    inv_invoice_vatcode: getData.inv_invoice_vatcode,
                    inv_invoice_name: getData.inv_invoice_name,
                    inv_invoice_address: getData.inv_invoice_address,
                    inv_invoice_fname: getData.inv_invoice_fname,
                    inv_invoice_lname: getData.inv_invoice_lname,
                    inv_invoice_mainfname: getData.inv_invoice_mainfname,
                    inv_invoice_mainlname: getData.inv_invoice_mainlname,
                    inv_invoice_mainphone: getData.inv_invoice_mainphone,
                    inv_invoice_mainemail: getData.inv_invoice_mainemail,
                    inv_invoice_provinceid: getData.inv_invoice_provinceid,
                    inv_invoice_subprovinceid: getData.inv_invoice_subprovinceid,
                    inv_invoice_zipcodeid: getData.inv_invoice_zipcodeid,
                    inv_invoice_districtid: getData.inv_invoice_districtid,
                    inv_invoice_comprefixid: getData.inv_invoice_comprefixid,
                    inv_invoice_comprefixname: getData.inv_invoice_comprefixname,
                    inv_invoice_taxid: getData.inv_invoice_taxid,
                    inv_invoice_businesstype: getData.inv_invoice_businesstype,
                    inv_invoice_branchname: getData.inv_invoice_branchname,
                    inv_invoice_memid: getData.inv_invoice_memid,
                    inv_invoice_vat: getData.inv_invoice_vat
                }, _define_property(_obj, "inv_invoice_totalvat", getData.inv_invoice_totalvat), _define_property(_obj, "inv_invoice_tax", getData.inv_invoice_tax), _define_property(_obj, "inv_invoice_totaltax", getData.inv_invoice_totaltax), _define_property(_obj, "inv_invoice_paytype", getData.inv_invoice_paytype), _define_property(_obj, "inv_invoice_totalnetvat", getData.inv_invoice_totalnetvat), _define_property(_obj, "inv_invoice_canceldate", getData.inv_invoice_canceldate ? moment(getData.inv_invoice_canceldate).format("DD/MM/YYYY") : ""), _obj));
                var pay = [];
                // getData.map((ele) =>
                pay.push({
                    id: nanoid(),
                    inv_invoice_paytype: getData.inv_invoice_paytype,
                    inv_invoice_totalnet: getData.inv_invoice_totalnet,
                    inv_invoice_ramark: getData.inv_invoice_ramark,
                    inv_invoice_taxstatus: getData.inv_invoice_taxstatus,
                    inv_invoice_issuedate: getData.inv_invoice_issuedate
                });
                // );
                setPayment(pay);
                setTaxSwitch(getData.inv_invoice_taxstatus == 1 ? true : false);
                setSumrowTax(getData.inv_invoice_totaltax);
                setSumrowVat(getData.inv_invoice_totalvat);
                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                    companyName: getData.inv_invoice_businesstype == 2 ? filterTextAndNum(getData.inv_invoice_comprefixname ? getData.inv_invoice_comprefixname : "") + " " + filterTextAndNum(getData.inv_invoice_name ? getData.inv_invoice_name : "") + " " + filterTextAndNum(getData.inv_invoice_suffixname ? getData.inv_invoice_suffixname : "") : filterTextAndNum(getData.inv_invoice_prefixid == 1 && "นาย" || getData.inv_invoice_prefixid == 2 && "นาง" || getData.inv_invoice_prefixid == 3 && "นางสาว" || getData.inv_invoice_prefixid == 4 && "ไม่ระบุ" || getData.inv_invoice_prefixid == "" && "") + " " + filterTextAndNum(getData.inv_invoice_fname) + " " + filterTextAndNum(getData.inv_invoice_lname),
                    companyBranch: getData.inv_invoice_branchname ? getData.inv_invoice_branchname : "",
                    companyTaxId: getData.inv_invoice_taxid ? getData.inv_invoice_taxid : "",
                    companyAddress: getData.inv_invoice_address,
                    companyProvince: getData.Invprovinceid ? JSON.parse(getData.Invprovinceid.province_name).th : "",
                    companyDistrict: getData.Invdistrictid ? JSON.parse(getData.Invdistrictid.subdistrict_name).th : "",
                    companySubDistrict: getData.Invsubprovinceid ? JSON.parse(getData.Invsubprovinceid.district_name).th : "",
                    companyZipCode: getData.inv_invoice_zipcodeid ? getData.inv_invoice_zipcodeid : "",
                    contractName: getData.inv_invoice_mainfname && getData.inv_invoice_mainlname ? getData.inv_invoice_mainfname + " " + getData.inv_invoice_mainlname : "",
                    contactPhone: getData.inv_invoice_mainphone ? getData.inv_invoice_mainphone : "",
                    contactEmail: getData.inv_invoice_mainemail ? getData.inv_invoice_mainemail : ""
                }));
                setSumrowTotalNet(getData.inv_invoice_totalprice);
                var arrFile = [];
                getData === null || getData === void 0 ? void 0 : getData.InvFile.map(function(ele) {
                    return arrFile.push({
                        id: nanoid(),
                        inv_file_url: ele.inv_file_url,
                        type: "update",
                        inv_file_id: ele.inv_file_id
                    });
                });
                setDocPath(arrFile);
                var datalistData = [];
                getData.InvDetail.map(function(ele) {
                    return datalistData.push({
                        rowID: nanoid(),
                        inv_detail_amount: ele.inv_detail_amount ? ele.inv_detail_amount : 0,
                        inv_detail_id: ele.inv_detail_id ? ele.inv_detail_id : "",
                        inv_detail_discount: ele.inv_detail_discount ? ele.inv_detail_discount : 0,
                        inv_detail_discountreal: ele.inv_detail_discountreal ? ele.inv_detail_discountreal : 0,
                        inv_detail_discounttype: ele.inv_detail_discounttype ? ele.inv_detail_discounttype : 1,
                        inv_detail_name: ele.inv_detail_name ? ele.inv_detail_name : "",
                        inv_detail_net: ele.inv_detail_net ? ele.inv_detail_net : 0,
                        inv_detail_price: ele.inv_detail_price ? ele.inv_detail_price : 0,
                        inv_detail_pricediscount: ele.inv_detail_pricediscount ? ele.inv_detail_pricediscount : 0,
                        inv_detail_remark: ele.inv_detail_remark ? ele.inv_detail_remark : "",
                        inv_detail_tax: ele.inv_detail_tax ? ele.inv_detail_tax : 0,
                        inv_detail_taxtype: ele.inv_detail_taxtype ? ele.inv_detail_taxtype : 0,
                        inv_detail_totalprice: ele.inv_detail_totalprice ? ele.inv_detail_totalprice : 0,
                        inv_detail_unit: ele.inv_detail_unit ? ele.inv_detail_unit : "",
                        inv_detail_vat: ele.inv_detail_vat ? ele.inv_detail_vat : 0,
                        inv_detail_vatnet: ele.inv_detail_vatnet ? ele.inv_detail_vatnet : 0,
                        inv_detail_vatprice: ele.inv_detail_vatprice ? ele.inv_detail_vatprice : 0,
                        type: "update"
                    });
                });
                setProductRow(datalistData);
                setSumDiscount(getData.inv_invoice_discountreal);
                setRemark(getData.inv_invoice_ramark ? getData.inv_invoice_ramark : "");
            }
        }
        if (getAllMstBusinessReducer.data) {
            var datas = getAllMstBusinessReducer.data.data.filter(function(item) {
                return item.bus_business_id !== null && item.bus_business_status == 3;
            });
            if (datas && datas.length > 0) {
                setSupplierInfos(datas.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        bus_business_company: item.bus_business_businesstype === 2 ? filterTextAndNum(item.bus_business_comprefixname) + " " + filterTextAndNum(item.bus_business_name) + " " + filterTextAndNum(item.bus_business_suffixname) : item.bus_business_businesstype === 1 ? getPrefixName(item.bus_business_prefixid) + filterTextAndNum(item.bus_business_fname) + " " + filterTextAndNum(item.bus_business_lname) : "ไม่ระบุชื่อธุรกิจ " + (index + 1)
                    });
                }));
            }
        }
    }, [
        getAllMstBusinessReducer,
        getInvoiceByIDReducer
    ]);
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.bus_business_company
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#f26f3a"
                    },
                    children: item.bus_business_taxid
                })
            ]
        }, item.bus_business_id);
    };
    var addPayment = function() {
        setPayment(function(pay) {
            return _to_consumable_array(pay).concat([
                {
                    id: nanoid(),
                    pay_typeid: 1,
                    pay_name: "",
                    inv_invoice_ramark: "",
                    type: "create"
                }
            ]);
        });
    };
    useEffect(function() {
        if (!dataID) {
            var pay = [];
            pay.push({
                id: nanoid(),
                inv_invoice_issuedate: moment().format("DD/MM/YYYY"),
                inv_invoice_paytype: 1,
                inv_invoice_totalnet: sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax,
                inv_invoice_ramark: "",
                inv_invoice_taxstatus: taxSwitch == true ? 1 : 2,
                type: "create"
            });
            setPayment(pay);
        }
    }, [
        dataID,
        sumrowTotalNet,
        sumDiscount,
        sumrowVat,
        sumrowTax
    ]);
    var dataSteps = [
        "สร้างใบเสร็จ",
        "รับชำระ",
        "เสร็จสิ้น"
    ];
    var dataSteps1 = [
        "ยกเลิก"
    ];
    var optionsMstTax = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 1,
            label: "1%"
        },
        {
            value: 2,
            label: "2%"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 5,
            label: "5%"
        }
    ];
    var optionsMstVat = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 7,
            label: "7%"
        },
        {
            value: 10,
            label: "10%"
        }
    ];
    var handleOpenPrint = function() {
        var _ref = _async_to_generator(function() {
            var blob, url, newWindow, fileName;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(PagePrintPDF, {
                                data: dataPrint,
                                partnerInfo: partnerInfo,
                                sumDiscount: sumDiscount,
                                sumrowVat: sumrowVat,
                                sumrowTax: sumrowTax,
                                sumrowTotalNet: sumrowTotalNet
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        // เปิด PDF ในหน้าต่างใหม่
                        newWindow = window.open(url, "_blank");
                        // เตรียมปุ่มดาวน์โหลด
                        if (newWindow) {
                            fileName = "ใบเสร็จ".concat(moment().format("YYYYMMDD_HHmm"), ".pdf");
                            // Inject ปุ่มดาวน์โหลดลงในแท็บใหม่
                            newWindow.document.write("\n      <html>\n        <head>\n          <title>".concat(fileName, '</title>\n        </head>\n        <body style="margin:0;">\n          <iframe src="').concat(url, '" width="100%" height="100%" style="border:none;"></iframe>\n        </body>\n      </html>\n      '));
                        } else {
                            alert("ไม่สามารถเปิดหน้าต่างใหม่ได้ กรุณาอนุญาต pop-up");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOpenPrint() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownload = function() {
        var _ref = _async_to_generator(function() {
            var blob, url, link;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(PagePrintPDF, {
                                data: dataPrint,
                                partnerInfo: partnerInfo,
                                sumDiscount: sumDiscount,
                                sumrowVat: sumrowVat,
                                sumrowTax: sumrowTax,
                                sumrowTotalNet: sumrowTotalNet
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        link = document.createElement("a");
                        link.href = url;
                        link.download = "ใบเสร็จ".concat(moment().format("YYYYMMDD_HHmm"), ".pdf"); // ตั้งชื่อไฟล์
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    // const componentRef = useRef();
    // const handlePrint = useReactToPrint({
    //   documentTitle: `ใบเสร็จ${moment().format("DDMMYYYYHHmmss")}`,
    //   content: () => componentRef.current,
    // });
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายรับ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบเสร็จรับเงิน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: dataID ? "แก้ใบเสร็จ" : "สร้างใบเสร็จ"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: dataID ? "แก้ไขใบเสร็จ" : "สร้างใบเสร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    console.log("formdataPayload", formdataPayload);
                    console.log("values", values);
                    if (!dataID) {
                        var createData = [];
                        productRow.map(function(ele) {
                            return createData.push({
                                inv_detail_amount: parseInt(ele.inv_detail_amount),
                                inv_detail_discount: parseFloat(ele.inv_detail_discount),
                                inv_detail_discountreal: parseFloat(ele.inv_detail_discountreal),
                                inv_detail_discounttype: parseInt(ele.inv_detail_discounttype),
                                inv_detail_name: ele.inv_detail_name,
                                inv_detail_net: parseFloat(ele.inv_detail_net),
                                inv_detail_price: parseFloat(ele.inv_detail_price),
                                inv_detail_pricediscount: parseFloat(ele.inv_detail_pricediscount),
                                inv_detail_remark: ele.inv_detail_remark,
                                inv_detail_tax: parseFloat(ele.inv_detail_tax),
                                inv_detail_taxtype: parseInt(ele.inv_detail_taxtype),
                                inv_detail_totalprice: parseFloat(ele.inv_detail_totalprice),
                                inv_detail_unit: ele.inv_detail_unit,
                                inv_detail_vat: parseFloat(ele.inv_detail_vat),
                                inv_detail_vatnet: parseFloat(ele.inv_detail_vatnet),
                                inv_detail_vatprice: parseFloat(ele.inv_detail_vatprice)
                            });
                        });
                        var createFile = [];
                        docPath.map(function(ele) {
                            return createFile.push({
                                inv_file_url: ele.inv_file_url
                            });
                        });
                        var dataForm = {
                            inv_invoice_totallist: parseInt(sumrowQty),
                            inv_invoice_businessid: values.inv_invoice_businessid,
                            inv_invoice_billid: null,
                            inv_invoice_expiredate: null,
                            inv_invoice_paytype: payment[0].inv_invoice_paytype,
                            inv_invoice_tag: null,
                            inv_invoice_status: values.inv_invoice_status ? values.inv_invoice_status : 1,
                            inv_invoice_refercode: values.inv_invoice_refercode ? values.inv_invoice_refercode : "",
                            inv_invoice_categoryid: values.inv_invoice_categoryid ? values.inv_invoice_categoryid : null,
                            inv_invoice_suffixname: values.inv_invoice_suffixname ? values.inv_invoice_suffixname : "",
                            inv_invoice_vatcode: values.inv_invoice_vatcode ? values.inv_invoice_vatcode : "",
                            inv_invoice_name: values.inv_invoice_name ? values.inv_invoice_name : "",
                            inv_invoice_address: values.inv_invoice_address ? values.inv_invoice_address : "",
                            inv_invoice_fname: values.inv_invoice_fname ? values.inv_invoice_fname : "",
                            inv_invoice_lname: values.inv_invoice_lname ? values.inv_invoice_lname : "",
                            inv_invoice_mainfname: values.inv_invoice_mainfname ? values.inv_invoice_mainfname : "",
                            inv_invoice_mainlname: values.inv_invoice_mainlname ? values.inv_invoice_mainlname : "",
                            inv_invoice_mainphone: values.inv_invoice_mainphone ? values.inv_invoice_mainphone : "",
                            inv_invoice_mainemail: values.inv_invoice_mainemail ? values.inv_invoice_mainemail : "",
                            inv_invoice_provinceid: values.inv_invoice_provinceid ? values.inv_invoice_provinceid : null,
                            inv_invoice_subprovinceid: values.inv_invoice_subprovinceid ? values.inv_invoice_subprovinceid : null,
                            inv_invoice_zipcodeid: values.inv_invoice_zipcodeid ? values.inv_invoice_zipcodeid : null,
                            inv_invoice_districtid: values.inv_invoice_districtid ? values.inv_invoice_districtid : null,
                            inv_invoice_comprefixid: values.inv_invoice_comprefixid ? values.inv_invoice_comprefixid : null,
                            inv_invoice_comprefixname: values.inv_invoice_comprefixname ? values.inv_invoice_comprefixname : "",
                            inv_invoice_taxid: values.inv_invoice_taxid ? values.inv_invoice_taxid : "",
                            inv_invoice_businesstype: values.inv_invoice_businesstype ? values.inv_invoice_businesstype : null,
                            inv_invoice_branchname: values.inv_invoice_branchname ? values.inv_invoice_branchname : "",
                            inv_invoice_memid: values.inv_invoice_memid ? values.inv_invoice_memid : null,
                            inv_invoice_issuedate: values.inv_invoice_issuedate ? moment(values.inv_invoice_issuedate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                            inv_invoice_ramark: remark,
                            inv_invoice_vattype: parseInt(values.inv_invoice_vattype),
                            inv_invoice_totalprice: parseFloat(sumrowTotalNet),
                            inv_invoice_discounttype: values.inv_invoice_discounttype,
                            inv_invoice_discount: values.inv_invoice_discount ? parseFloat(values.inv_invoice_discount) : 0,
                            inv_invoice_discountreal: parseFloat(sumDiscount),
                            inv_invoice_pricediscount: parseFloat(sumrowBeforeVat),
                            inv_invoice_vat: values.inv_invoice_vat ? values.inv_invoice_vat : 0,
                            inv_invoice_totalvat: parseFloat(sumrowVat),
                            inv_invoice_tax: values.inv_invoice_tax ? values.inv_invoice_tax : 0,
                            inv_invoice_totaltax: parseFloat(sumrowTax),
                            inv_invoice_totalnet: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2),
                            inv_invoice_totalnetvat: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat),
                            invdetailcreate: createData,
                            filecreate: createFile
                        };
                        console.log("dataFormCreate", dataForm);
                        dispatch(createInvoice(dataForm, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        var createData1 = [];
                        var updateData = [];
                        productRow.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return createData1.push({
                                inv_detail_amount: ele.inv_detail_amount ? parseInt(ele.inv_detail_amount) : null,
                                inv_detail_discount: parseFloat(ele.inv_detail_discount),
                                inv_detail_discountreal: parseFloat(ele.inv_detail_discountreal),
                                inv_detail_discounttype: parseInt(ele.inv_detail_discounttype),
                                inv_detail_name: ele.inv_detail_name,
                                inv_detail_net: ele.inv_detail_net ? parseFloat(ele.inv_detail_net) : null,
                                inv_detail_price: parseFloat(ele.inv_detail_price),
                                inv_detail_pricediscount: parseFloat(ele.inv_detail_pricediscount),
                                inv_detail_remark: ele.inv_detail_remark,
                                inv_detail_tax: parseFloat(ele.inv_detail_tax),
                                inv_detail_taxtype: parseInt(ele.inv_detail_taxtype),
                                inv_detail_totalprice: parseFloat(ele.inv_detail_totalprice),
                                inv_detail_unit: ele.inv_detail_unit,
                                inv_detail_vat: parseFloat(ele.inv_detail_vat),
                                inv_detail_vatnet: parseFloat(ele.inv_detail_vatnet),
                                inv_detail_vatprice: parseFloat(ele.inv_detail_vatprice)
                            });
                        });
                        productRow.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return updateData.push({
                                inv_detail_amount: parseInt(ele.inv_detail_amount),
                                inv_detail_discount: parseFloat(ele.inv_detail_discount),
                                inv_detail_discountreal: parseFloat(ele.inv_detail_discountreal),
                                inv_detail_discounttype: parseInt(ele.inv_detail_discounttype),
                                inv_detail_name: ele.inv_detail_name,
                                inv_detail_net: parseFloat(ele.inv_detail_net),
                                inv_detail_price: parseFloat(ele.inv_detail_price),
                                inv_detail_pricediscount: parseFloat(ele.inv_detail_pricediscount),
                                inv_detail_remark: ele.inv_detail_remark,
                                inv_detail_tax: parseFloat(ele.inv_detail_tax),
                                inv_detail_taxtype: parseInt(ele.inv_detail_taxtype),
                                inv_detail_totalprice: parseFloat(ele.inv_detail_totalprice),
                                inv_detail_unit: ele.inv_detail_unit,
                                inv_detail_vat: parseFloat(ele.inv_detail_vat),
                                inv_detail_vatnet: parseFloat(ele.inv_detail_vatnet),
                                inv_detail_vatprice: parseFloat(ele.inv_detail_vatprice),
                                inv_detail_id: ele.inv_detail_id
                            });
                        });
                        var createFile1 = [];
                        var updateFile = [];
                        docPath.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return createFile1.push({
                                inv_file_url: ele.inv_file_url
                            });
                        });
                        docPath.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return updateFile.push({
                                inv_file_id: ele.inv_file_id
                            });
                        });
                        var dataForm1 = {
                            inv_invoice_businessid: values.inv_invoice_businessid,
                            inv_invoice_paytype: payment[0].inv_invoice_paytype,
                            inv_invoice_totallist: parseInt(sumrowQty),
                            inv_invoice_id: values.inv_invoice_id,
                            inv_invoice_refercode: values.inv_invoice_refercode ? values.inv_invoice_refercode : "",
                            inv_invoice_status: values.inv_invoice_status,
                            inv_invoice_categoryid: values.inv_invoice_categoryid,
                            inv_invoice_suffixname: values.inv_invoice_suffixname,
                            inv_invoice_vatcode: values.inv_invoice_vatcode,
                            inv_invoice_name: values.inv_invoice_name,
                            inv_invoice_address: values.inv_invoice_address,
                            inv_invoice_fname: values.inv_invoice_fname,
                            inv_invoice_lname: values.inv_invoice_lname,
                            inv_invoice_mainfname: values.inv_invoice_mainfname,
                            inv_invoice_mainlname: values.inv_invoice_mainlname,
                            inv_invoice_mainphone: values.inv_invoice_mainphone,
                            inv_invoice_mainemail: values.inv_invoice_mainemail,
                            inv_invoice_provinceid: values.inv_invoice_provinceid,
                            inv_invoice_subprovinceid: values.inv_invoice_subprovinceid,
                            inv_invoice_zipcodeid: values.inv_invoice_zipcodeid,
                            inv_invoice_districtid: values.inv_invoice_districtid,
                            inv_invoice_comprefixid: values.inv_invoice_comprefixid,
                            inv_invoice_comprefixname: values.inv_invoice_comprefixname,
                            inv_invoice_taxid: values.inv_invoice_taxid,
                            inv_invoice_businesstype: values.inv_invoice_businesstype,
                            inv_invoice_branchname: values.inv_invoice_branchname,
                            inv_invoice_memid: values.inv_invoice_memid,
                            inv_invoice_issuedate: values.inv_invoice_issuedate ? moment(values.inv_invoice_issuedate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                            inv_invoice_ramark: remark,
                            inv_invoice_vattype: parseInt(values.inv_invoice_vattype),
                            inv_invoice_totalprice: parseFloat(sumrowTotalNet),
                            inv_invoice_discounttype: values.inv_invoice_discounttype ? values.inv_invoice_discounttype : 1,
                            inv_invoice_discount: values.inv_invoice_discount ? parseFloat(values.inv_invoice_discount) : 0,
                            inv_invoice_discountreal: parseFloat(sumDiscount),
                            inv_invoice_pricediscount: parseFloat(sumrowBeforeVat),
                            inv_invoice_vat: values.inv_invoice_vat ? values.inv_invoice_vat : 0,
                            inv_invoice_totalvat: parseFloat(sumrowVat),
                            inv_invoice_tax: values.inv_invoice_tax ? values.inv_invoice_tax : 0,
                            inv_invoice_totaltax: parseFloat(sumrowTax),
                            inv_invoice_totalnet: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2),
                            inv_invoice_totalnetvat: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat),
                            invdetailcreate: createData1,
                            invdetailupdate: updateData,
                            invdetaildelete: productRowDel,
                            filecreate: createFile1,
                            fileupdate: updateFile,
                            filedelete: docPathDel
                        };
                        dispatch(updateInvoice(dataForm1, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                        console.log("update", dataForm1);
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto mb-4 pb-3 pagezoom",
                                        children: /*#__PURE__*/ _jsx(StepperLabelWizard, {
                                            dataLabel: values.inv_invoice_status == 3 ? dataSteps1 : dataSteps,
                                            activeStep: stepper
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "pt-3 px-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เลขที่ใบเสร็จ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_code",
                                                                            className: "form-control",
                                                                            placeholder: "RE-2410000001",
                                                                            value: values.inv_invoice_code,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "วันที่ออกเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ออกเอกสาร",
                                                                            selected: values.inv_invoice_issuedate,
                                                                            onChange: function(date) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_issuedate: date
                                                                                }));
                                                                            },
                                                                            className: "w-100 datepicker2",
                                                                            value: values.inv_invoice_issuedate,
                                                                            disabled: values.inv_invoice_status == 1 ? false : true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิงระบบ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_refer",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิงระบบ",
                                                                            value: values.inv_invoice_refer,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_refercode",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิง",
                                                                            value: values.inv_invoice_refercode,
                                                                            disabled: values.inv_invoice_status == 1 ? false : true,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_refercode: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            style: {
                                                                                zIndex: 11
                                                                            },
                                                                            children: "ลูกค้า"
                                                                        }),
                                                                        values.inv_invoice_status == 1 ? /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                                            items: supplierInfos,
                                                                            placeholder: "กรุณากรอกชื่อลูกค้า",
                                                                            onSelect: function(item) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_memid: item.bus_business_memid ? item.bus_business_memid : values.inv_invoice_memid,
                                                                                    inv_invoice_businessid: item.bus_business_id ? item.bus_business_id : values.inv_invoice_businessid,
                                                                                    inv_invoice_businesstype: item.bus_business_businesstype ? item.bus_business_businesstype : values.inv_invoice_businesstype,
                                                                                    inv_invoice_taxid: item.bus_business_taxid ? item.bus_business_taxid : values.inv_invoice_taxid,
                                                                                    inv_invoice_categoryid: item.bus_business_categoryid ? item.bus_business_categoryid : values.inv_invoice_categoryid,
                                                                                    inv_invoice_comprefixname: item.bus_business_comprefixname ? item.bus_business_comprefixname : values.inv_invoice_comprefixname,
                                                                                    inv_invoice_name: item.bus_business_name ? item.bus_business_name : values.inv_invoice_name,
                                                                                    inv_invoice_suffixname: item.bus_business_suffixname ? item.bus_business_suffixname : values.inv_invoice_suffixname,
                                                                                    inv_invoice_vatcode: item.bus_business_vatcode ? item.bus_business_vatcode : values.inv_invoice_vatcode,
                                                                                    inv_invoice_branchname: item.bus_business_branchname ? item.bus_business_branchname : values.inv_invoice_branchname,
                                                                                    inv_invoice_prefixid: item.bus_business_prefixid ? item.bus_business_prefixid : values.inv_invoice_prefixid,
                                                                                    inv_invoice_fname: item.bus_business_fname ? item.bus_business_fname : values.inv_invoice_fname,
                                                                                    inv_invoice_lname: item.bus_business_lname ? item.bus_business_lname : values.inv_invoice_lname,
                                                                                    inv_invoice_address: item.bus_business_address ? item.bus_business_address : values.inv_invoice_address,
                                                                                    inv_invoice_provinceid: item.bus_business_provinceid ? item.bus_business_provinceid : values.inv_invoice_provinceid,
                                                                                    inv_invoice_subprovinceid: item.bus_business_subprovinceid ? item.bus_business_subprovinceid : values.inv_invoice_subprovinceid,
                                                                                    inv_invoice_districtid: item.bus_business_districtid ? item.bus_business_districtid : values.inv_invoice_districtid,
                                                                                    inv_invoice_zipcodeid: item.bus_business_zipcodeid ? item.bus_business_zipcodeid : values.inv_invoice_zipcodeid,
                                                                                    inv_invoice_mainfname: item.bus_business_mainfname ? item.bus_business_mainfname : values.inv_invoice_mainfname,
                                                                                    inv_invoice_mainlname: item.bus_business_mainlname ? item.bus_business_mainlname : values.inv_invoice_mainlname,
                                                                                    inv_invoice_mainphone: item.bus_business_mainphone ? item.bus_business_mainphone : values.inv_invoice_mainphone,
                                                                                    inv_invoice_mainemail: item.bus_business_mainemail ? item.bus_business_mainemail : values.inv_invoice_mainemail
                                                                                }));
                                                                                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                                                                                    companyName: item.bus_business_company,
                                                                                    companyBranch: item.bus_business_branchname && item.bus_business_branchname != "" && item.bus_business_branchname != null ? item.bus_business_branchname : "-",
                                                                                    companyTaxId: item.bus_business_taxid && item.bus_business_taxid != "" && item.bus_business_taxid != null ? item.bus_business_taxid : "-",
                                                                                    contractName: item.bus_business_mainfname && item.bus_business_mainfname != "" && item.bus_business_mainlname != null ? filterTextAndNum(item.bus_business_mainfname) + " " + filterTextAndNum(item.bus_business_mainlname) : "-",
                                                                                    companyAddress: item.bus_business_address && item.bus_business_address != "" && item.bus_business_address != null ? filterTextAndNum("".concat(item.bus_business_address)) : "",
                                                                                    companyProvince: item.bus_business_provinceid && item.bus_business_provinceid != "" && item.bus_business_provinceid != null ? JSON.parse(item.Busprovinceid.province_name).th : "",
                                                                                    companyDistrict: item.bus_business_subprovinceid && item.bus_business_subprovinceid != "" && item.bus_business_subprovinceid != null ? JSON.parse(item.Bussubprovinceid.district_name).th : "",
                                                                                    companySubDistrict: item.bus_business_districtid && item.bus_business_districtid != "" && item.bus_business_districtid != null ? JSON.parse(item.Busdistrictid.subdistrict_name).th : "",
                                                                                    companyZipCode: item.bus_business_zipcodeid && item.bus_business_zipcodeid != "" && item.bus_business_zipcodeid != null ? filterTextAndNum("".concat(item.bus_business_zipcodeid)) : "",
                                                                                    contactPhone: item.bus_business_mainphone && item.bus_business_mainphone != "" && item.bus_business_mainphone != null ? filterTextAndNum("".concat(item.bus_business_mainphone)) : "-",
                                                                                    contactEmail: item.bus_business_mainemail && item.bus_business_mainemail != "" && item.bus_business_mainemail != null ? filterTextAndNum("".concat(item.bus_business_mainemail)) : "-"
                                                                                }));
                                                                            },
                                                                            onClear: function() {
                                                                                setFieldValue("inv_invoice_businessid", "");
                                                                                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                                                                                    companyName: "",
                                                                                    companyBranch: "-",
                                                                                    companyTaxId: "-",
                                                                                    companyAddress: "",
                                                                                    companyProvince: "",
                                                                                    companyDistrict: "",
                                                                                    companySubDistrict: "",
                                                                                    companyZipCode: "",
                                                                                    contractName: "",
                                                                                    contactPhone: "-",
                                                                                    contactEmail: "-"
                                                                                }));
                                                                            },
                                                                            autoFocus: true,
                                                                            formatResult: formatResult,
                                                                            inputSearchString: partnerInfo.companyName ? partnerInfo.companyName : "",
                                                                            fuseOptions: {
                                                                                keys: [
                                                                                    "bus_business_company",
                                                                                    "bus_business_taxid"
                                                                                ]
                                                                            },
                                                                            resultStringKeyName: "bus_business_company",
                                                                            styling: {
                                                                                height: "50px",
                                                                                borderRadius: "10px",
                                                                                boxShadow: "none",
                                                                                zIndex: 10,
                                                                                border: !values.inv_invoice_memid ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                            },
                                                                            showIcon: false,
                                                                            className: "scrollSearchAutocomplete",
                                                                            readOnly: true
                                                                        }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_name",
                                                                            className: "form-control",
                                                                            placeholder: "กรุณากรอกชื่อลูกค้า",
                                                                            value: partnerInfo.companyName,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ประเภทราคา"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "inv_invoice_vattype",
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_vattype: e.value
                                                                                }));
                                                                            },
                                                                            className: "w-100 select-st-1",
                                                                            isDisabled: values.inv_invoice_status == 1 ? false : true,
                                                                            options: optionsMstPriceType,
                                                                            placeholder: "เลือกประเภทราคา",
                                                                            value: optionsMstPriceType.filter(function(item) {
                                                                                return item.value === values.inv_invoice_vattype;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ผู้จัดทำเอกสาร"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "creBy",
                                                                            className: "form-control",
                                                                            placeholder: "admim",
                                                                            value: adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? adminInfo.userFullName : "-",
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: values.inv_invoice_status == 3 && /*#__PURE__*/ _jsx("div", {
                                                                    className: "pt-4 fw-bold text-center tc-8 fs-24",
                                                                    children: values.inv_invoice_canceldate ? "ยกเลิกรายการแล้ว : ".concat(values.inv_invoice_canceldate) : ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ชื่อลูกค้า"
                                                                        }),
                                                                        partnerInfo.companyName && partnerInfo.companyName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companyName
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "สาขา : ",
                                                                                        partnerInfo.companyBranch
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "ทะเบียนนิติบุคคล :",
                                                                                        " ",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "tc-5",
                                                                                            children: partnerInfo.companyTaxId
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-18 mb-2",
                                                                            children: "-"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ที่อยู่"
                                                                        }),
                                                                        partnerInfo.companyAddress && partnerInfo.companyAddress != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companyAddress
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companySubDistrict + " " + partnerInfo.companyDistrict
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-18 mb-2",
                                                                            children: "-"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ข้อมูลผู้ติดต่อ"
                                                                        }),
                                                                        partnerInfo.contractName && partnerInfo.contractName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "ชื่อ : ",
                                                                                        partnerInfo.contractName
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "เบอร์โทรศัพท์ : ",
                                                                                        partnerInfo.contactPhone
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "อีเมล : ",
                                                                                        partnerInfo.contactEmail
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-18 mb-2",
                                                                            children: "-"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ProductData, {
                                        formdisabled: formdisabled,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        values: values,
                                        errors: errors,
                                        setFieldValue: setFieldValue,
                                        handleChange: handleChange,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        optionsVat: optionsVat,
                                        sumrowNoDiscount: sumrowNoDiscount,
                                        setSumrowNoDiscount: setSumrowNoDiscount,
                                        sumrowBeforeVat: sumrowBeforeVat,
                                        setSumrowBeforeVat: setSumrowBeforeVat,
                                        sumrowTotalNet: sumrowTotalNet,
                                        setSumrowTotalNet: setSumrowTotalNet,
                                        sumrowQty: sumrowQty,
                                        setSumrowQty: setSumrowQty,
                                        sumrowPrice: sumrowPrice,
                                        setSumrowPrice: setSumrowPrice,
                                        sumrowDiscount: sumrowDiscount,
                                        setSumrowDiscount: setSumrowDiscount,
                                        sumDiscount: sumDiscount,
                                        setSumDiscount: setSumDiscount,
                                        sumrowVat: sumrowVat,
                                        setSumrowVat: setSumrowVat,
                                        sumrowTax: sumrowTax,
                                        setSumrowTax: setSumrowTax,
                                        docPath: docPath,
                                        setDocPath: setDocPath,
                                        docPathDel: docPathDel,
                                        setDocPathDel: setDocPathDel,
                                        columdisplay: columdisplay,
                                        setValues: setValues,
                                        remark: remark,
                                        setRemark: setRemark,
                                        poID: poID,
                                        modalObj: modalObj,
                                        setModalObj: setModalObj,
                                        setIsLoading: setIsLoading,
                                        productRowDel: productRowDel,
                                        setProductRowDel: setProductRowDel,
                                        optionsMstVat: optionsMstVat,
                                        optionsMstTax: optionsMstTax
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "px-3 !bg-[rgb(176 3 18)]",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-9",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "fs-24 fw-bold",
                                                                    children: "การรับชำะเงิน"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "วันที่ออกเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ออกเอกสาร",
                                                                            selected: values.inv_invoice_issuedate,
                                                                            disabled: true,
                                                                            onChange: function(date) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_issuedate: date
                                                                                }));
                                                                            },
                                                                            className: "w-100 datepicker2",
                                                                            value: values.inv_invoice_issuedate
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-2",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "row gx-xl-4",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "col-12 mb-3",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "fs-20 tc-5 fw-bold",
                                                                children: "รายการชำระเงิน"
                                                            })
                                                        })
                                                    }),
                                                    payment.map(function(item, index) {
                                                        return /*#__PURE__*/ _jsxs("div", {
                                                            className: "row gx-xl-4",
                                                            keys: index,
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4 col-md-4",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-md-1",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-20 fw-bold pt-3",
                                                                                    children: [
                                                                                        index + 1,
                                                                                        "."
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-md-11",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "เอกสาร"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            placeholder: "เลือกเอกสาร",
                                                                                            name: "inv_invoice_paytype",
                                                                                            isDisabled: values.inv_invoice_status == 1 ? false : true,
                                                                                            onChange: function(e) {
                                                                                                setPayment(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            inv_invoice_paytype: e.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            className: "w-100 select-st-1",
                                                                                            options: optionsMstPayment,
                                                                                            value: optionsMstPayment.filter(function(d) {
                                                                                                return d.value == item.inv_invoice_paytype;
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-3 col-md-3",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "จำนวนเงินที่ชำระ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "inv_invoice_totalnet",
                                                                                className: "form-control",
                                                                                placeholder: "จำนวนเงินที่ชำระ",
                                                                                value: NumberFormat(item.inv_invoice_totalnet, 2),
                                                                                disabled: true,
                                                                                onChange: function(e) {
                                                                                    setPayment(function(prev) {
                                                                                        return prev.map(function(el) {
                                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                inv_invoice_totalnet: e.target.value
                                                                                            }) : el;
                                                                                        });
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4 col-md-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "หมายเหตุ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "inv_invoice_ramark",
                                                                                className: "form-control",
                                                                                placeholder: "หมายเหตุ",
                                                                                disabled: values.inv_invoice_status == 1 ? false : true,
                                                                                value: item.inv_invoice_ramark,
                                                                                onChange: function(e) {
                                                                                    setPayment(function(prev) {
                                                                                        return prev.map(function(el) {
                                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                inv_invoice_ramark: e.target.value
                                                                                            }) : el;
                                                                                        });
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-11",
                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                    direction: "row",
                                                                    justifyContent: "space-between",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-20 fw-bold tc-5 mb-3",
                                                                            children: "หัก ณ ที่จ่าย"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Group, {
                                                                            children: /*#__PURE__*/ _jsx(FormControlLabel, {
                                                                                control: /*#__PURE__*/ _jsx(Switch, {
                                                                                    checked: taxSwitch
                                                                                }),
                                                                                label: "",
                                                                                disabled: true
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-9 col-md-1"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3 sm pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "หัก ณ ที่จ่าย"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "inv_invoice_tax",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกหัก ณ ที่จ่าย",
                                                                                options: optionsMstTax,
                                                                                isDisabled: true,
                                                                                value: optionsMstTax.filter(function(item) {
                                                                                    return item.value === values.inv_invoice_tax;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                                        inv_invoice_tax: e.value
                                                                                    })); // Update formData state
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "มูลค่าถูกหัก ณ ที่จ่าย"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            className: "form-control",
                                                                            placeholder: "มูลค่าถูกหัก ณ ที่จ่าย",
                                                                            value: NumberFormat(sumrowTax, 2),
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-6 col-md-1"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-1"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-3 col-md-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-end",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "tc-6 text-white py-3 px-3 !bg-[#B00412] mt-4",
                                                                            style: {
                                                                                borderRadius: 10
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "fs-20 me-10",
                                                                                    children: "รับชำระเงินรวมทั้งสิน"
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("span", {
                                                                                    className: "fs-24 ",
                                                                                    children: [
                                                                                        NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2),
                                                                                        " ",
                                                                                        "บาท"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-20 tc-7 mt-3 text-end",
                                                                        children: "ต้องรับชำระเงินอีก 0.00 บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4",
                                style: {
                                    minWidth: "1000px"
                                },
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Button, {
                                            type: "button",
                                            className: "btn-st-8 fs-14 border-0 px-3 me-3",
                                            onClick: function() {
                                                handleOpenPrint();
                                                handleDownload();
                                            },
                                            disabled: values.inv_invoice_status == 2 ? false : true,
                                            children: [
                                                /*#__PURE__*/ _jsx("i", {
                                                    className: "iprinter"
                                                }),
                                                "พิมพ์เอกสาร"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/invoice");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ยกเลิก"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            onClick: function(e) {
                                                handleSubmit();
                                                e.preventDefault();
                                            // setFieldValue("inv_invoice_status", 1);ห
                                            },
                                            className: "btn-st-3 me-3",
                                            disabled: values.inv_invoice_status == 3 ? true : false,
                                            children: values.inv_invoice_status == 1 ? "บันทึกร่าง" : "บันทึก"
                                        }),
                                        values.inv_invoice_status == 1 && /*#__PURE__*/ _jsx(ButtonGroup, {
                                            className: " btn-group-st-1 me-3",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                type: "submit",
                                                onClick: function(e) {
                                                    handleSubmit();
                                                    e.preventDefault();
                                                    setFieldValue("inv_invoice_status", 2);
                                                },
                                                children: "ชำระเงิน"
                                            })
                                        }),
                                        values.inv_invoice_status == 2 && /*#__PURE__*/ _jsx(Link, {
                                            className: "btn text-white",
                                            onClick: function() {
                                                setModalDel(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: true
                                                    });
                                                });
                                            },
                                            style: {
                                                marginRight: 3,
                                                background: "#565DFF"
                                            },
                                            children: "ยกเลิกรายการ"
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: "ยกเลิกรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    dataID: dataID
                })
            })
        ]
    });
}
function ProductData(param) {
    var formdisabled = param.formdisabled, productRow = param.productRow, setProductRow = param.setProductRow, values = param.values, errors = param.errors, setFieldValue = param.setFieldValue, setValues = param.setValues, optionsMstDiscountType = param.optionsMstDiscountType, optionsVat = param.optionsVat, handleChange = param.handleChange, columdisplay = param.columdisplay, poID = param.poID, sumrowNoDiscount = param.sumrowNoDiscount, setSumrowNoDiscount = param.setSumrowNoDiscount, sumrowBeforeVat = param.sumrowBeforeVat, setSumrowBeforeVat = param.setSumrowBeforeVat, sumrowTotalNet = param.sumrowTotalNet, setSumrowTotalNet = param.setSumrowTotalNet, sumrowQty = param.sumrowQty, setSumrowQty = param.setSumrowQty, sumrowPrice = param.sumrowPrice, setSumrowPrice = param.setSumrowPrice, sumrowDiscount = param.sumrowDiscount, setSumrowDiscount = param.setSumrowDiscount, sumDiscount = param.sumDiscount, setSumDiscount = param.setSumDiscount, sumrowVat = param.sumrowVat, setSumrowVat = param.setSumrowVat, sumrowTax = param.sumrowTax, setSumrowTax = param.setSumrowTax, remark = param.remark, setRemark = param.setRemark, docPath = param.docPath, setDocPath = param.setDocPath, docPathDel = param.docPathDel, setDocPathDel = param.setDocPathDel, modalObj = param.modalObj, setModalObj = param.setModalObj, setIsLoading = param.setIsLoading, productRowDel = param.productRowDel, setProductRowDel = param.setProductRowDel, optionsMstVat = param.optionsMstVat, optionsMstTax = param.optionsMstTax;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), collapse = _useState1[0], setCollapse = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), customSort = _useState2[0], setCustomSort = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), rowCount = _useState3[0], setRowCount = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionsWarehouse = _useState4[0], setOptionsWarehouse = _useState4[1];
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            var formData = new FormData();
            formData.append("upload_tmp_invoice", e.target.files[0]);
            dispatch(uploadInvoice(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("doc");
        }
    };
    var uploadInvoiceReducer = useAppSelector(function(state) {
        return state.uploadInvoiceReducer;
    });
    useEffect(function() {
        if (textImg == "doc") {
            setIsLoading(uploadInvoiceReducer.isFetching);
            if (uploadInvoiceReducer.data) {
                console.log("uploadInvoiceReducer", uploadInvoiceReducer.data.data);
                setDocPath(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: nanoid(),
                            inv_file_url: uploadInvoiceReducer.data.data,
                            type: "create"
                        }
                    ]);
                });
                setTextImg("");
            }
        }
    }, [
        uploadInvoiceReducer
    ]);
    var deleteDocument = function(removeId, item) {
        setDocPath(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                inv_file_id: item.inv_file_id
            };
            setDocPathDel(_to_consumable_array(docPathDel).concat([
                del
            ]));
        }
    };
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 1200,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState5[0], setModal = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pr-product-sort"
    }), 2), modalSort = _useState6[0], setModalSort = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-load-document"
    }), 2), modalLoadDocument = _useState7[0], setModalLoadDocument = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDisplayColumn = _useState8[0], setModalDisplayColumn = _useState8[1];
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceAfterDiscount = 0;
        var priceVat = 0;
        var ums = 0;
        var discount = 0;
        var pricetax = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.inv_detail_amount);
            var productPrice = parseFloat(pd.inv_detail_price);
            var productDiscount = parseFloat(pd.inv_detail_discount);
            var productVat = parseFloat(pd.inv_detail_vatprice);
            var productTax = parseFloat(pd.inv_detail_tax);
            var disType = parseFloat(pd.inv_detail_discounttype);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
            }
            if (hasValidPrice) {
                price += productPrice;
                discount += productDiscount;
            }
            if (hasValidQty && hasValidPrice) {
                ums += productPrice * productQty;
                var type = disType == 1 ? productDiscount : productPrice * productDiscount / 100 * productQty;
                priceAfterDiscount += productPrice * productQty - type;
                priceVat += productVat;
                pricetax += productTax;
            }
            setSumrowNoDiscount(ums);
            setSumrowQty(qty);
            setSumrowPrice(price);
            setSumrowDiscount(discount);
            setSumrowBeforeVat(priceAfterDiscount);
            setSumrowTotalNet(priceAfterDiscount);
            var discountAA = values.inv_invoice_discounttype == 1 ? values.inv_invoice_discount : priceAfterDiscount * values.inv_invoice_discount / 100;
            setSumDiscount(discountAA);
        });
    };
    useEffect(function() {
        sumQty(productRow);
    }, [
        productRow
    ]);
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    {
                        rowID: nanoid(),
                        inv_detail_name: "",
                        inv_detail_unit: "",
                        inv_detail_amount: "",
                        inv_detail_price: 0,
                        inv_detail_discounttype: 1,
                        inv_detail_discount: 0,
                        inv_detail_discountreal: 0,
                        inv_detail_pricediscount: 0,
                        inv_detail_vat: 0,
                        inv_detail_vatprice: 0,
                        inv_detail_net: 0,
                        inv_detail_remark: "",
                        inv_detail_totalprice: 0,
                        inv_detail_vatnet: 0,
                        inv_detail_taxtype: 0,
                        inv_detail_tax: 0,
                        type: "create",
                        is_checked: false
                    }
                ]);
            });
        }
    };
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(1);
        }
    }, []);
    var onDeleteProductRow = function(removeId, item) {
        setProductRow(function(doc) {
            return doc.filter(function(item) {
                return item.rowID !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                inv_detail_id: item.inv_detail_id
            };
            setProductRowDel(_to_consumable_array(productRowDel).concat([
                del
            ]));
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                style: {
                    overflowX: "auto",
                    maxWidth: "100%",
                    overflowY: "hidden",
                    paddingBottom: "20px"
                },
                children: /*#__PURE__*/ _jsx(DndContext, {
                    sensors: sensors,
                    collisionDetection: closestCenter,
                    modifiers: [
                        restrictToVerticalAxis
                    ],
                    children: /*#__PURE__*/ _jsx(SortableContext, {
                        items: productRow,
                        strategy: verticalListSortingStrategy,
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "column_resize_table table1 table-striped ",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 200
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#666CFF] !text-white",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#666CFF] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#B00412] !text-white",
                                                children: "ราคา/หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#B00412] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 110
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่าก่อนส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 120
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ประเภทส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 120
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่ารวมสุทธิ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หมายเหตุ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {}),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 20
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: productRow.map(function(item, index) {
                                        return /*#__PURE__*/ _jsx(Productrow, {
                                            item: item,
                                            index: index,
                                            setProductRow: setProductRow,
                                            optionsMstDiscountType: optionsMstDiscountType,
                                            optionsVat: optionsVat,
                                            customSort: customSort,
                                            rowCount: rowCount,
                                            addProductRow: addProductRow,
                                            optionsWarehouse: optionsWarehouse,
                                            values: values,
                                            onDeleteProductRow: onDeleteProductRow
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tfoot", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prCode",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowQty, 0),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prCode",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowPrice, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prBeDiscount",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowNoDiscount, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prDiscount",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowDiscount, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prCode",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowTotalNet, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-3",
                children: /*#__PURE__*/ _jsxs("fieldset", {
                    disabled: formdisabled,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mb-3 pagezoom",
                            children: /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-3 me-3",
                                onClick: function() {
                                    return addProductRow(1);
                                },
                                disabled: values.inv_invoice_status == 1 ? false : true,
                                children: "เพิ่มแถว"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "row",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold",
                                                            children: "สรุปข้อมูล"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumrowTotalNet, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "ส่วนลด "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "number",
                                                                                                    name: "inv_invoice_discount",
                                                                                                    className: "form-control",
                                                                                                    placeholder: "",
                                                                                                    value: values.inv_invoice_discount,
                                                                                                    onChange: function(e) {
                                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                            inv_invoice_discount: e.target.value
                                                                                                        }));
                                                                                                        var discount = values.inv_invoice_discounttype == 1 ? e.target.value : sumrowTotalNet * e.target.value / 100;
                                                                                                        setSumDiscount(discount);
                                                                                                        var total = sumrowTotalNet - discount;
                                                                                                        setSumrowTax(total * values.inv_invoice_tax / 100);
                                                                                                        setSumrowVat(total * values.inv_invoice_vat / 100);
                                                                                                    },
                                                                                                    style: {
                                                                                                        borderRight: 0,
                                                                                                        borderTopRightRadius: 0,
                                                                                                        borderBottomRightRadius: 0,
                                                                                                        width: "80px"
                                                                                                    },
                                                                                                    disabled: values.inv_invoice_status == 1 ? sumrowTotalNet == 0 ? true : false : true
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                                    as: "select",
                                                                                                    name: "inv_invoice_discounttype",
                                                                                                    onChange: function(e) {
                                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                            inv_invoice_discounttype: e.value
                                                                                                        }));
                                                                                                        var type = e.value == 1 ? values.inv_invoice_discount : sumrowTotalNet * values.inv_invoice_discount / 100;
                                                                                                        var total = sumrowTotalNet - type;
                                                                                                        setSumDiscount(type);
                                                                                                        setSumrowTax(total * values.inv_invoice_tax / 100);
                                                                                                        setSumrowVat(total * values.inv_invoice_vat / 100);
                                                                                                    },
                                                                                                    className: "w-100  select-st-2",
                                                                                                    options: optionsMstDiscountType,
                                                                                                    placeholder: "",
                                                                                                    value: optionsMstDiscountType.filter(function(item) {
                                                                                                        return item.value === values.inv_invoice_discounttype;
                                                                                                    }),
                                                                                                    style: {
                                                                                                        borderLeft: 0,
                                                                                                        borderTopLeftRadius: 0,
                                                                                                        borderBottomLeftRadius: 0,
                                                                                                        width: "80px"
                                                                                                    },
                                                                                                    isDisabled: values.inv_invoice_status == 1 ? false : true
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    value: NumberFormat(sumDiscount, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2 pt-2",
                                                                                            children: "ภาษีมูลค่าเพิ่ม"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "inv_invoice_vat",
                                                                                            onChange: function(e) {
                                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                    inv_invoice_vat: e.value
                                                                                                }));
                                                                                                var total = sumrowTotalNet - sumDiscount;
                                                                                                setSumrowVat(total * e.value / 100);
                                                                                            },
                                                                                            options: optionsMstVat,
                                                                                            value: optionsMstVat.filter(function(item) {
                                                                                                return item.value === values.inv_invoice_vat;
                                                                                            }),
                                                                                            isDisabled: values.inv_invoice_status == 1 ? false : true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    disabled: true,
                                                                                    value: NumberFormat(sumrowVat, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "หัก ณ ที่จ่าย"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "inv_invoice_tax",
                                                                                            onChange: function(e) {
                                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                    inv_invoice_tax: e.value
                                                                                                }));
                                                                                                var total = sumrowTotalNet - sumDiscount;
                                                                                                setSumrowTax(total * e.value / 100);
                                                                                            },
                                                                                            options: optionsMstTax,
                                                                                            value: optionsMstTax.filter(function(item) {
                                                                                                return item.value === values.inv_invoice_tax;
                                                                                            }),
                                                                                            isDisabled: values.inv_invoice_status == 1 ? false : true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    disabled: true,
                                                                                    value: NumberFormat(sumrowTax, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-2",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2 text-end",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white text-end fs-24",
                                                                style: {
                                                                    background: "#B00412",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "row",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "col-6",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-3",
                                                                controlId: "exampleForm.ControlTextarea1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "fw-bold fs-18",
                                                                        children: "หมายเหตุ"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        as: "textarea",
                                                                        rows: 3,
                                                                        value: remark,
                                                                        disabled: values.inv_invoice_status == 1 ? false : true,
                                                                        style: {
                                                                            backgroundColor: "rgb(255 255 255 / 12%)"
                                                                        },
                                                                        onChange: function(e) {
                                                                            return setRemark(e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function(e) {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf",
                                                                onChange: function(e) {
                                                                    handlePreviewFile(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: docPath.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Link, {
                                                                                to: item.inv_file_url,
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "docfile",
                                                                                    children: /*#__PURE__*/ _jsx("span", {
                                                                                        className: "icon pdf",
                                                                                        children: item.inv_file_url.substring(68)
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function(e) {
                                                                                    return deleteDocument(item.id, item);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsVat = _param.optionsVat, poID = _param.poID, onDeleteProductRow = _param.onDeleteProductRow, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsVat",
        "poID",
        "onDeleteProductRow"
    ]);
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    disabled: values.inv_invoice_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    value: item.inv_detail_name,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_name: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    value: item.inv_detail_unit,
                    disabled: values.inv_invoice_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_unit: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#EDEDFF]",
                style: {
                    color: "#666CFF"
                },
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    disabled: values.inv_invoice_status == 1 ? false : true,
                    className: "form-control formv text-center border-0 me-2 !bg-[#EDEDFF]",
                    value: item.inv_detail_amount,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = item.inv_detail_discounttype == 1 ? item.inv_detail_discount : item.inv_detail_price * item.inv_detail_discount / 100 * item.inv_detail_amount;
                                    var price = parseFloat(item.inv_detail_price * e.target.value - disPrice);
                                    console.log("priceamount", price);
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_amount: parseInt(e.target.value),
                                        inv_detail_totalprice: parseFloat(item.inv_detail_price * e.target.value),
                                        inv_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#EDEDFF]"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#F6E1E3]",
                style: {
                    color: "#B00412"
                },
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2 !bg-[#F6E1E3]",
                    disabled: values.inv_invoice_status == 1 ? false : true,
                    value: item.inv_detail_price,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = item.inv_detail_discounttype == 1 ? item.inv_detail_discount : e.target.value * item.inv_detail_discount / 100 * item.inv_detail_amount;
                                    var price = parseFloat(e.target.value * item.inv_detail_amount - disPrice);
                                    console.log("pricePrice", price);
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_price: parseFloat(e.target.value),
                                        inv_detail_totalprice: parseFloat(e.target.value * item.inv_detail_amount),
                                        inv_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#F6E1E3]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? NumberFormat(item.inv_detail_totalprice) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.inv_detail_discount,
                    disabled: values.inv_invoice_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = item.inv_detail_discounttype == 1 ? e.target.value : item.inv_detail_price * e.target.value / 100 * item.inv_detail_amount;
                                    var price = item.inv_detail_price * item.inv_detail_amount - disPrice;
                                    console.log("pricediscount", price);
                                    console.log("disPricediscount", disPrice);
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_discount: parseFloat(e.target.value),
                                        inv_detail_discountreal: parseFloat(disPrice),
                                        inv_detail_pricediscount: parseFloat(price),
                                        inv_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsxs("select", {
                    value: item.inv_detail_discounttype,
                    disabled: values.inv_invoice_status == 1 ? false : true,
                    style: {
                        width: "100%",
                        border: "0px solid rgb(223, 225, 229)",
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = e.currentTarget.value == 1 ? item.inv_detail_discount : item.inv_detail_price * item.inv_detail_discount / 100 * item.inv_detail_amount;
                                    var price = item.inv_detail_price * item.inv_detail_amount - disPrice;
                                    console.log("pricetype", price);
                                    console.log("disPricetype", disPrice);
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_discounttype: parseInt(e.currentTarget.value),
                                        inv_detail_discountreal: parseFloat(disPrice),
                                        inv_detail_pricediscount: parseFloat(price),
                                        inv_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            disabled: true,
                            children: "เลือกส่วนลด"
                        }, "default"),
                        optionsMstDiscountType && optionsMstDiscountType.map(function(v, index) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: v.value,
                                children: v.label
                            }, index);
                        })
                    ]
                }) : "-"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? NumberFormat(item.inv_detail_net) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.inv_detail_remark,
                    disabled: values.inv_invoice_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_remark: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                style: {
                    width: "20px"
                },
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "btn btn-delete-file ",
                    onClick: function(e) {
                        return onDeleteProductRow(item.rowID, item);
                    },
                    disabled: values.inv_invoice_status == 1 ? false : true
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var updateInvoiceCancelReducer = useAppSelector(function(state) {
        return state.updateInvoiceCancelReducer;
    });
    useEffect(function() {
        setIsLoading(updateInvoiceCancelReducer.isFetching);
        if (updateInvoiceCancelReducer.data && !updateInvoiceCancelReducer.isError) {
            setTextsuccess("ยกเลิกรายการสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateInvoiceCancel());
            dispatch(getInvoiceByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        updateInvoiceCancelReducer
    ]);
    var onClickModel = function() {
        if (dataID) {
            dispatch(updateInvoiceCancel(dataID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "",
        children: /*#__PURE__*/ _jsxs("center", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการยกเลิกรายการนี้"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
// register ฟอนต์
Font.register({
    family: "THSarabun",
    fonts: [
        {
            src: thsarabun
        },
        {
            src: thsarabunBold,
            fontWeight: "bold"
        }
    ]
});
var styles = StyleSheet.create({
    page: {
        fontFamily: "THSarabun",
        fontSize: 12,
        padding: 30,
        backgroundColor: "#fff",
        lineHeight: 1.4
    },
    headerRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12,
        alignItems: "center"
    },
    logo: {
        width: 90
    },
    subTitle: {
        fontSize: 12,
        marginBottom: 2,
        color: "#333"
    },
    title: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#B00412"
    },
    titleBox: {
        textAlign: "right"
    },
    titleCenter: {
        textAlign: "center"
    },
    sectionGroup: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12
    },
    col6: {
        flex: 1
    },
    textEnd: {
        textAlign: "right"
    },
    sectionBox: {
        flex: 1,
        padding: 6,
        marginRight: 8,
        borderBottom: "1px solid #CCC"
    },
    sectionLabel: {
        fontSize: 12,
        color: "#555"
    },
    sectionValue: {
        fontSize: 12,
        fontWeight: "bold",
        marginTop: 2
    },
    docInfoBox: {
        flex: 1,
        padding: 6,
        marginLeft: 8,
        borderRadius: 4,
        backgroundColor: "#FDECEC"
    },
    docInfoRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 4
    },
    docLabel: {
        fontSize: 12,
        color: "#333"
    },
    docValue: {
        fontSize: 12,
        fontWeight: "bold"
    },
    table: {
        display: "table",
        width: "auto",
        marginTop: 2
    },
    tableRow: {
        flexDirection: "row"
    },
    tableHeader: {
        flex: 1,
        borderRight: "1px solid #E2E8F0",
        backgroundColor: "#F6E1E3",
        padding: 6,
        fontSize: 12,
        fontWeight: "bold",
        textAlign: "center"
    },
    tableCell: {
        flex: 1,
        borderRight: "0px solid #E2E8F0",
        borderTop: "0px solid #E2E8F0",
        padding: 5,
        fontSize: 11,
        textAlign: "center"
    },
    footer: {
        marginTop: 24,
        textAlign: "right",
        fontSize: 11
    },
    footerSection: {
        paddingVertical: 8,
        fontSize: 11.5,
        marginVertical: 6
    },
    footerRow: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    footerColLeft: {
        flex: 1,
        justifyContent: "flex-start"
    },
    footerColCenter: {
        flex: 1,
        alignItems: "center"
    },
    footerColRight: {
        flex: 1,
        alignItems: "flex-end"
    },
    signSection: {
        paddingVertical: 8,
        fontSize: 11.5,
        marginVertical: 6,
        paddingHorizontal: 12
    },
    signRow: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    signCol: {
        flex: 1,
        alignItems: "center"
    },
    signLine: {
        color: "#d8d8d8",
        marginBottom: 4
    },
    signDate: {
        borderBottomWidth: 1,
        borderColor: "#d8d8d8",
        paddingHorizontal: 45,
        marginBottom: 4
    }
});
var PagePrintPDF = function(param) {
    var data = param.data, partnerInfo = param.partnerInfo, sumDiscount = param.sumDiscount, sumrowVat = param.sumrowVat, sumrowTax = param.sumrowTax, sumrowTotalNet = param.sumrowTotalNet;
    var _data_BlBilling, _data_InvDetail, _data_InvDetail1, _data_InvDetail2, _data_InvDetail3, _data_InvDetail4;
    var invCode = data.inv_invoice_code;
    var billCode = (_data_BlBilling = data.BlBilling) === null || _data_BlBilling === void 0 ? void 0 : _data_BlBilling.bl_billing_code;
    var discounttype = data.inv_invoice_discounttype ? data.inv_invoice_discounttype : 1;
    var discount = data.inv_invoice_discount ? data.inv_invoice_discount : 0;
    var totalnet = data.inv_invoice_totalnet ? data.inv_invoice_totalnet : 0;
    var paytype = data.inv_invoice_paytype == 1 && "เงินสด" || data.inv_invoice_paytype == 2 && "โอนธนาคาร" || data.inv_invoice_paytype == 3 && "เช็คเงินสด";
    var taxstatus = data.inv_invoice_taxstatus;
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.headerRow,
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/logopardesco.png",
                            style: styles.logo
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flex: 1,
                                alignItems: "flex-end"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.subTitle,
                                    children: "(ต้นฉบับ)"
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.title,
                                    children: "ใบเสร็จรับเงิน/ใบกำกับภาษี"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ขาย :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บริษัท พาร์เดสโก้ กรุ๊ป จำากัด (สำนักงานใหญ่)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "0105568029236"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "วริธร สวยงาม"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "0949280297"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                backgroundColor: "#F6E1E3",
                                borderRadius: 5,
                                padding: 6,
                                width: 150
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "เลขที่เอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: invCode !== null && invCode !== void 0 ? invCode : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ออกเอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ครบกำหนด :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.inv_invoice_expiredate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "อ้างอิง :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: billCode !== null && billCode !== void 0 ? billCode : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 240,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลูกค้า :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyName,
                                                " ",
                                                partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                " ",
                                                partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.contractName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactPhone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactEmail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.table,
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: [
                                "รายการ",
                                "จำนวน",
                                "ราคาต่อหน่วย",
                                "ส่วนลด",
                                "ราคารวม"
                            ].map(function(h, i) {
                                return /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeader,
                                    children: h
                                }, i);
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.InvDetail) && (data === null || data === void 0 ? void 0 : (_data_InvDetail = data.InvDetail) === null || _data_InvDetail === void 0 ? void 0 : _data_InvDetail.length) > 0 ? data === null || data === void 0 ? void 0 : (_data_InvDetail1 = data.InvDetail) === null || _data_InvDetail1 === void 0 ? void 0 : _data_InvDetail1.map(function(ele, i) {
                            return /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: [
                                            styles.tableCell,
                                            {
                                                alignItems: "flex-start"
                                            }
                                        ],
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: "".concat(i + 1, ". ").concat(ele.inv_detail_name)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: ele.inv_detail_remark ? "(" + ele.inv_detail_remark + ")" : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.inv_detail_amount
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.inv_detail_price, 2)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.inv_detail_discounttype == 1 ? NumberFormat(ele.inv_detail_discount, 2) : ele.inv_detail_discount + "%"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.inv_detail_net, 2)
                                        })
                                    })
                                ]
                            }, i);
                        }) : /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: [
                                    styles.tableCell,
                                    {
                                        flex: 1
                                    }
                                ],
                                children: "ไม่พบข้อมูล"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: ((_data_InvDetail2 = data.InvDetail) === null || _data_InvDetail2 === void 0 ? void 0 : _data_InvDetail2.length) > 5 && 100 || ((_data_InvDetail3 = data.InvDetail) === null || _data_InvDetail3 === void 0 ? void 0 : _data_InvDetail3.length) < 5 && 150 || ((_data_InvDetail4 = data.InvDetail) === null || _data_InvDetail4 === void 0 ? void 0 : _data_InvDetail4.length) > 10 && 10,
                        borderBottom: "1px solid #ebecec",
                        borderTop: "1px solid #ebecec",
                        padding: "10px 2px"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 40,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4,
                                        fontWeight: "bold"
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 30
                                        },
                                        children: "สรุป"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าก่อนส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "ส่วนลด",
                                                " ",
                                                discounttype == 1 ? NumberFormat(discount, 2) : discount,
                                                " ",
                                                discounttype == 1 ? "บาท" : "เปอร์เซ็น"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าหลังหักส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "ภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "หัก ณ ที่จ่าย ",
                                                taxstatus == 1 ? data.inv_invoice_tax : 0,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(taxstatus == 1 ? sumrowTax : 0, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: [
                                styles.docValue,
                                {
                                    width: 200,
                                    paddingRight: 10,
                                    fontSize: 13
                                }
                            ],
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    backgroundColor: "#F6E1E3",
                                    borderRadius: 5,
                                    padding: 6
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            flexDirection: "row",
                                            marginBottom: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: 100
                                                },
                                                children: "มูลค่าสุทธิรวม"
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: [
                                                    styles.textEnd,
                                                    {
                                                        width: 50,
                                                        marginRight: 3,
                                                        color: "#b00412",
                                                        fontWeight: 700
                                                    }
                                                ],
                                                children: NumberFormat(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    flex: 1
                                                },
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: [
                                            styles.titleCenter,
                                            {
                                                flexDirection: "row",
                                                marginBottom: 4
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 200
                                            },
                                            children: [
                                                "(",
                                                " ",
                                                ThaiBahtText(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2),
                                                " ",
                                                ")"
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        borderBottom: "1px solid #ebecec",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "ชำระเงิน"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 80
                                        },
                                        children: "วันที่ชำระ :"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            flex: 1
                                        },
                                        children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 80
                                        },
                                        children: "ช่องทางการชำระ :"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 30
                                        },
                                        children: paytype
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: [
                                            styles.textEnd,
                                            {
                                                width: 80,
                                                marginRight: 3
                                            }
                                        ],
                                        children: NumberFormat(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            flex: 1
                                        },
                                        children: "บาท"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: 40,
                            paddingRight: 10
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "หมายเหตุ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 250,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        children: data.inv_invoice_ramark ? data.inv_invoice_ramark : ""
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.footerSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.footerRow,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColLeft,
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    children: [
                                        "ในนาม ",
                                        (partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.companyName) || "-"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColCenter,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColRight,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.signSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.signRow,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้จ่าย"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.signCol,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        paddingRight: 4
                                    }
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5,
                                            width: "50%"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้รับเงิน"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 4,
                                            paddingLeft: 4,
                                            borderBottom: "1px soild #ebecec",
                                            width: "100%",
                                            textAlign: "center"
                                        },
                                        children: (data === null || data === void 0 ? void 0 : data.inv_invoice_issuedate) ? moment(data.inv_invoice_issuedate).format("DD/MM/YYYY") : ""
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var PagePrint = function(param) {
    var data = param.data, partnerInfo = param.partnerInfo, sumDiscount = param.sumDiscount, sumrowVat = param.sumrowVat, sumrowTax = param.sumrowTax, sumrowTotalNet = param.sumrowTotalNet;
    var _data_InvDetail, _data_InvDetail1, _data_InvDetail2, _data_InvDetail3, _data_InvDetail4, _data_InvDetail5, _data_InvDetail6, _data_InvDetail7;
    var discounttype = data.inv_invoice_discounttype ? data.inv_invoice_discounttype : 1;
    var discount = data.inv_invoice_discount ? data.inv_invoice_discount : 0;
    var totalnet = data.inv_invoice_totalnet ? data.inv_invoice_totalnet : 0;
    var paytype = data.inv_invoice_paytype == 1 && "เงินสด" || data.inv_invoice_paytype == 2 && "โอนธนาคาร" || data.inv_invoice_paytype == 3 && "เช็คเงินสด";
    var taxstatus = data.inv_invoice_taxstatus;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "text-[12.5px] text-[#2C2C2C] mb-1",
                style: {
                    width: "210mm",
                    height: "297mm",
                    padding: "5px 30px",
                    margin: "0",
                    background: "white",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row gx-xl-4",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/images/logopardesco.png",
                                        className: "w-[100px]"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6 text-end",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ml-5",
                                            children: "(ต้นฉบับ)"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-18 text-danger fw-bold",
                                            children: "ใบเสร็จรับเงิน/ใบกำกับภาษี"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #ebecec"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ผู้ขาย :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "บริษัท พาร์เดสโก้ กรุ๊ป จำากัด (สำนักงานใหญ่ )"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: "0105568029236"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[60px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #ebecec"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "วริธร สวยงาม"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "094-928-0297"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                style: {
                                    background: "#F6E1E3",
                                    borderRadius: 5
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "เลขที่เอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.inv_invoice_code
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ออกเอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ครบกำหนด :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.inv_invoice_expiredate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-end mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "อ้างอิง :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.BlBilling ? data.BlBilling.bl_billing_code : "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ลูกค้า :"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: [
                                                    partnerInfo.companyName,
                                                    " ",
                                                    partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[70px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[50px]",
                                                children: "ผู้ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contractName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactPhone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactEmail
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000]"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-1",
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "w-full table-print",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 2,
                                        borderColor: "#F6E1E3"
                                    },
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "6%",
                                                style: {
                                                    width: "6%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคาต่อหน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคารวม"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: data === null || data === void 0 ? void 0 : (_data_InvDetail = data.InvDetail) === null || _data_InvDetail === void 0 ? void 0 : _data_InvDetail.map(function(ele, i) {
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            style: {
                                                height: "30px"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsxs("td", {
                                                    className: "border-x ellipsis",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(i + 1, ". ").concat(ele.inv_detail_name)
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(ele.inv_detail_remark ? "(" + ele.inv_detail_remark + ")" : "")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: ele.inv_detail_amount
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.inv_detail_price, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: ele.inv_detail_discounttype == 1 ? NumberFormat(ele.inv_detail_discount, 2) : ele.inv_detail_discount + "%"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.inv_detail_net, 2)
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end py-2 border-y ".concat(((_data_InvDetail1 = data.InvDetail) === null || _data_InvDetail1 === void 0 ? void 0 : _data_InvDetail1.length) > 5 && "mt-[100px]" || ((_data_InvDetail2 = data.InvDetail) === null || _data_InvDetail2 === void 0 ? void 0 : _data_InvDetail2.length) < 5 && "mt-[150px]" || ((_data_InvDetail3 = data.InvDetail) === null || _data_InvDetail3 === void 0 ? void 0 : _data_InvDetail3.length) > 10 && "mt-[0px]"),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[30px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold",
                                                children: [
                                                    /*#__PURE__*/ _jsx(AssignmentIcon, {
                                                        fontSize: "18",
                                                        className: "me-1"
                                                    }),
                                                    "สรุป"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ส่วนลด"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: discounttype == 1 ? NumberFormat(discount, 2) : discount
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[5px]",
                                                        children: discounttype == 1 ? "บาท" : "เปอร์เซ็น"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ภาษีมูลค่าเพิ่ม"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            data.inv_invoice_vat,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "หัก ณ ที่จ่าย"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            taxstatus == 1 ? data.inv_invoice_tax : 0,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(taxstatus == 1 ? sumrowTax : 0, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow w-[180px]",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "px-3 pt-3 pb-1 mt-3 mb-2",
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none fs-14 w-[90px] fw-bold",
                                                    children: "มูลค่าสุทธิรวม"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-end fw-bold text-[#B00412] fs-16 w-[80px]",
                                                    children: NumberFormat(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none text-[#000] pl-[10px] pt-1",
                                                    children: "บาท"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex mb-2",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-center text-[#000] w-[100px]",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "text-center text-[12.5px] text-[#000] font-semibold",
                                                    children: [
                                                        "(",
                                                        " ",
                                                        ThaiBahtText(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2),
                                                        " ",
                                                        ")"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end pt-3 border-b",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(PaymentsIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " ชำระเงิน"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe pr-[50px]",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none w-[120px]",
                                                    children: "วันที่ชำระ :"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-center fw-bold text-[#000] w-[50px]",
                                                    children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe pr-[10px]",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none w-[120px]",
                                                    children: "ช่องทางการชำระ :"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-center fw-bold text-[#000] w-[80px]",
                                                    children: paytype
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                    children: NumberFormat(taxstatus == 1 ? totalnet : sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none text-[#000] pl-[10px]",
                                                    children: "บาท"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end py-2",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(SpeakerNotesIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " หมายเหตุ"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe text-[#000] w-[220px] pr-[10px]",
                                        children: data.inv_invoice_ramark ? data.inv_invoice_ramark : ""
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-3 gap-3",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-start justify-start flex-col",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2",
                                        children: [
                                            "ในนาม ",
                                            partnerInfo.companyName
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-end justify-end flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3 px-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-5 gap-5",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้จ่าย"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้รับเงิน"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2 border-b px-[45px]",
                                            children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text-[12.5px] text-[#2C2C2C] mb-1",
                style: {
                    width: "210mm",
                    height: "297mm",
                    padding: "5px 30px",
                    margin: "0",
                    background: "white",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row gx-xl-4",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/images/logopardesco.png",
                                        className: "w-[100px]"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6 text-end",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ml-5",
                                            children: "(สำเนา)"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-18 text-danger fw-bold",
                                            children: "ใบเสร็จรับเงิน/ใบกำกับภาษี"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #ebecec"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ผู้ขาย :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "บริษัท พาร์เดสโก้ กรุ๊ป จำากัด (สำนักงานใหญ่ )"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: "0105568029236"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[60px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #ebecec"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "วริธร สวยงาม"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "094-928-0297"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                style: {
                                    background: "#F6E1E3",
                                    borderRadius: 5
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "เลขที่เอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.inv_invoice_code
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ออกเอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ครบกำหนด :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.inv_invoice_expiredate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-end mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "อ้างอิง :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.BlBilling ? data.BlBilling.bl_billing_code : "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ลูกค้า :"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: [
                                                    partnerInfo.companyName,
                                                    " ",
                                                    partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[70px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[50px]",
                                                children: "ผู้ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contractName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactPhone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactEmail
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000]"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-1",
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "w-full table-print",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 2,
                                        borderColor: "#F6E1E3"
                                    },
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "6%",
                                                style: {
                                                    width: "6%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคาต่อหน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคารวม"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: data === null || data === void 0 ? void 0 : (_data_InvDetail4 = data.InvDetail) === null || _data_InvDetail4 === void 0 ? void 0 : _data_InvDetail4.map(function(ele, i) {
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            style: {
                                                height: "30px"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsxs("td", {
                                                    className: "border-x ellipsis",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(i + 1, ". ").concat(ele.inv_detail_name)
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(ele.inv_detail_remark ? "(" + ele.inv_detail_remark + ")" : "")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: ele.inv_detail_amount
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.inv_detail_price, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: ele.inv_detail_discounttype == 1 ? NumberFormat(ele.inv_detail_discount, 2) : ele.inv_detail_discount + "%"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.inv_detail_net, 2)
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end py-2 border-y ".concat(((_data_InvDetail5 = data.InvDetail) === null || _data_InvDetail5 === void 0 ? void 0 : _data_InvDetail5.length) > 5 && "mt-[100px]" || ((_data_InvDetail6 = data.InvDetail) === null || _data_InvDetail6 === void 0 ? void 0 : _data_InvDetail6.length) < 5 && "mt-[150px]" || ((_data_InvDetail7 = data.InvDetail) === null || _data_InvDetail7 === void 0 ? void 0 : _data_InvDetail7.length) > 10 && "mt-[0px]"),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[30px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold",
                                                children: [
                                                    /*#__PURE__*/ _jsx(AssignmentIcon, {
                                                        fontSize: "18",
                                                        className: "me-1"
                                                    }),
                                                    "สรุป"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ส่วนลด"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: discounttype == 1 ? NumberFormat(discount, 2) : discount
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[5px]",
                                                        children: discounttype == 1 ? "บาท" : "เปอร์เซ็น"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ภาษีมูลค่าเพิ่ม"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            data.inv_invoice_vat,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "หัก ณ ที่จ่าย"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            data.inv_invoice_tax,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTax, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow w-[180px]",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "px-3 pt-3 pb-1 mt-3 mb-2",
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none fs-14 w-[90px] fw-bold",
                                                    children: "มูลค่าสุทธิรวม"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-end fw-bold text-[#B00412] fs-16 w-[80px]",
                                                    children: NumberFormat(totalnet, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none text-[#000] pl-[10px] pt-1",
                                                    children: "บาท"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex mb-2",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-center text-[#000] w-[100px]",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "text-center text-[12.5px] text-[#000] font-semibold",
                                                    children: [
                                                        "( ",
                                                        ThaiBahtText(totalnet, 2),
                                                        " )"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end pt-3 border-b",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(PaymentsIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " ชำระเงิน"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe pr-[50px]",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none w-[120px]",
                                                    children: "วันที่ชำระ :"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-center fw-bold text-[#000] w-[50px]",
                                                    children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe pr-[10px]",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none w-[120px]",
                                                    children: "ช่องทางการชำระ :"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-center fw-bold text-[#000] w-[80px]",
                                                    children: paytype
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                    children: NumberFormat(totalnet, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none text-[#000] pl-[10px]",
                                                    children: "บาท"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end py-2",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(SpeakerNotesIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " หมายเหตุ"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe text-[#000] w-[220px] pr-[10px]",
                                        children: data.inv_invoice_ramark ? data.inv_invoice_ramark : ""
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-3 gap-3",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-start justify-start flex-col",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2",
                                        children: [
                                            "ในนาม ",
                                            partnerInfo.companyName
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-end justify-end flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3 px-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-5 gap-5",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้จ่าย"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้รับเงิน"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2 border-b px-[45px]",
                                            children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
